import { Component } from '@angular/core';
import { AlertController, LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { ProductCreateFoodcostQuantityCostPage } from "../product-create-foodcost-quantity-cost/product-create-foodcost-quantity-cost";
import { IngredientsServices } from "../../../../ingredients/services";
import { ProductsServices } from '../../../services';
import { Globals } from '../../../../../globals';
import { ProductCreateWfoodcostInfoPage } from '../../product-create-without-foodcost/product-create-wfoodcost-info/product-create-wfoodcost-info';
import { TranslateService } from '@ngx-translate/core';
import { StockListPage } from '../../../../stock/stock-list/stock-list';

/**
 * Generated class for the ProductCreateFoodcostSelectIngPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-product-create-foodcost-select-ing',
  templateUrl: 'product-create-foodcost-select-ing.html',
})
export class ProductCreateFoodcostSelectIngPage {

  update_state: boolean = false;
  product_uid: string;
  products: any;
  product_measurement: any;
  product_name: any;
  product: any;

  prodings: any;
  selected_collapse: boolean = false;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public ingredientsServices: IngredientsServices,
    public toastCtrl: ToastController,
    public productsServices: ProductsServices,
    public globals: Globals,
    public translate: TranslateService,
    private alertCtrl: AlertController,) {

    this.update_state = this.navParams.get('update_state');
    this.product_uid = this.navParams.get('product_uid');
    this.products = this.navParams.get('products');
    this.product_measurement = this.navParams.get('product_measurement');
    this.product_name = this.navParams.get('product_name');
    this.product = this.navParams.get('product');

    this.productsServices.list_array_tmp.length = 0;
    this.productsServices.getListPartialSelect(this.globals.restaurant_uid);

    this.update_state = this.navParams.get('update_state');
  }

  ionViewCanLeave(): Promise<void> {
    return new Promise((resolve, reject) => {
      //Si el show_alert es true i no estem fen un update al plat
      if (this.productsServices.show_alert_delete && !this.update_state) {
        let alert = this.alertCtrl.create({
          title: this.translate.instant('general-atencion'),
          message: this.translate.instant('general-salir-proceso-creacion'),
          subTitle: this.translate.instant('general-se-eliminara-elemento'),
          buttons: [
            {
              text: this.translate.instant('general-no'),
              role: 'cancel',
              handler: () => {
                this.globals.side_menu_active = 'stock';
                reject();
              },
            },
            {
              text: this.translate.instant('general-si'),
              handler: () => {
                this.productsServices.afs.collection('products').doc(this.product_uid).delete();
                resolve();
                this.navCtrl.setRoot(StockListPage);
              },
            },
          ],
        });
        alert.present();
      } else {
        resolve();
      }
    });
  }

  openProductQuantCost() {

    if (this.productsServices.prodings_array_tmp.length > 0) {
      this.productsServices.show_alert_delete = false;

      if (this.update_state) {
        this.globals.GAtrackView('Products', 'Products - Select prodings - Update', this.globals.restaurant.email, 'Create/Update', 'Update select prodings', 'Products', this.product_name);
      } else {
        this.globals.GAtrackView('Products', 'Products - Select prodings - Create', this.globals.restaurant.email, 'Create/Update', 'Create select prodings', 'Products', this.product_name);
      }


      this.navCtrl.push(ProductCreateFoodcostQuantityCostPage, {
        product_measurement: this.product_measurement,
        products: this.products,
        product_uid: this.product_uid,
        update_state: this.update_state,
        product_name: this.product_name,
        product: this.product,
      });


    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-selecciona-ingrediente'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }


  }
  openCreateProduct() {
    this.productsServices.show_alert_delete = false;
    this.productsServices.quick_create = true;
    this.navCtrl.push(ProductCreateWfoodcostInfoPage);
  }
  async ionViewWillEnter() {
    this.ingredientsServices.getPagesIngredients('all', 0);
    this.ingredientsServices.page_active = 1;

    if (this.update_state) {
      this.prodings = this.products.foodcost;

      if (this.prodings != null) {
        if (Object.keys(this.prodings).length > 0) {

          this.productsServices.prodings_array_tmp = Array(); //Reiniciamos array para no tener los antiguos valores.
          var ingredients = await this.ingredientsServices.getIngredients(this.globals.restaurant_uid);
          for (let entry of this.prodings) {
            //Recuperamos los valores del providers a tratar

            //if type ing or prod
            if (entry.type == 'ingredient') {
              var index = ingredients.findIndex(x => x.UID == entry.uid);
              if (index >= 0) {
                var _array = Array();
                _array.push(entry.uid);
                _array.push(ingredients[index].name);
                _array.push(ingredients[index].measurement);
                _array.push('');
                _array.push(ingredients[index].tax);
                _array.push(ingredients[index].price_static);
                _array.push(ingredients[index].provider_static);
                _array.push(ingredients[index].tags);
                if (ingredients[index].allergens == undefined) {
                  ingredients[index].allergens = [];
                  _array.push(ingredients[index].allergens);
                } else {
                  _array.push(ingredients[index].allergens);
                }
                _array.push(ingredients[index].stock_alert);
                _array.push(ingredients[index].stock);
                _array.push(ingredients[index].sub_recipe);
                _array.push(entry.quantity);//cantidad
                _array.push(entry.quantity_gross);//cantidad bruta
                _array.push(entry.waste);//merma
                _array.push(entry.price_static);//preu final
                _array.push(this.products.price_static);//total
                _array.push(entry);//foodcost
                _array.push(this.products.real_weight);
                _array.push(ingredients[index].recipe);
                _array.push(ingredients[index].time);
                _array.push(ingredients[index].tools);
                _array.push(ingredients[index].image);
                _array.push('ingredient');
                this.productsServices.prodings_array_tmp.push(_array);
              }
            }
          }
        }
      }
    } else {
      this.prodings = Array();
      this.productsServices.prodings_array_tmp = Array();
    }
    this.productsServices.prodings_array_tmp = [...this.productsServices.prodings_array_tmp];
  }
  searchIngredientNode(value, type) {
    this.ingredientsServices.searchIngredientNode(value, type);
  }
  collapse() {
    this.selected_collapse = !this.selected_collapse;
  }
}



// WEBPACK FOOTER //
// ./src/pages/products/product-create/product-create-foodcost/product-create-foodcost-select-ing/product-create-foodcost-select-ing.ts